/* BikeLink – kategorifliser (Runde 8): lat innlasting av bevegelsesklipp + innglidning */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  function load(v) {
    if (v.dataset.loaded) return;
    v.dataset.loaded = '1';
    [['mp4', 'video/mp4'], ['webm', 'video/webm']].forEach(function (s) {
      var src = v.dataset[s[0]];
      if (!src) return;
      var el = document.createElement('source');
      el.src = src; el.type = s[1];
      v.appendChild(el);
    });
    v.load();
  }
  function play(link) {
    var v = link.querySelector('video');
    if (!v || reduce.matches) return;
    load(v);
    v.muted = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function pause(link) {
    var v = link.querySelector('video');
    if (v && !v.paused) v.pause();
  }
  function init(root) {
    root.querySelectorAll('[data-bl-tiles]').forEach(function (list) {
      if (list.dataset.blInit) return;
      list.dataset.blInit = '1';
      var links = list.querySelectorAll('[data-bl-tile]');
      links.forEach(function (link) {
        var v = link.querySelector('video');
        if (!v) return;
        v.addEventListener('playing', function () { link.classList.add('is-playing'); });
        v.addEventListener('pause', function () { link.classList.remove('is-playing'); });
        link.addEventListener('mouseenter', function () { if (fine.matches) play(link); });
        link.addEventListener('mouseleave', function () { if (fine.matches) pause(link); });
        link.addEventListener('focus', function () { if (fine.matches) play(link); });
        link.addEventListener('blur', function () { if (fine.matches) pause(link); });
      });
      if (!('IntersectionObserver' in window)) return;
      // Innglidning ved scroll
      if (!reduce.matches) {
        list.classList.add('is-armed');
        var ioReveal = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { list.classList.add('is-visible'); ioReveal.disconnect(); } });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
        ioReveal.observe(list);
      }
      // Mobil/berøring: spill av kun når flisen er godt synlig
      var ioPlay = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (fine.matches) return;
          if (e.isIntersecting && e.intersectionRatio >= 0.6) play(e.target); else pause(e.target);
        });
      }, { threshold: [0, 0.6] });
      links.forEach(function (l) { if (l.querySelector('video')) ioPlay.observe(l); });
      document.addEventListener('visibilitychange', function () { if (document.hidden) links.forEach(pause); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
